import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CardsWrapper } from "@sprout/client-components/dist/Cards";
import { useNavigationList } from "@sprout/list-navigation";
import { memo, useMemo } from "react";
import { Droppable } from "react-beautiful-dnd";
import { ItemType } from "sprout-graphql";
import { PostPageTodo } from "../PostPageTodo";
const PostPageTodoListTodosIncompleteMemo = /*#__PURE__*/ memo(function PostPageTodoListTodosIncompleteMemoMemo(props) {
    const { todos , disabled  } = props;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: todos.map((todo, index)=>{
            return /*#__PURE__*/ _jsx(PostPageTodo, {
                disabled: disabled,
                todo: todo,
                index: index
            }, todo.nodeId);
        })
    });
});
const PostPageTodoListTodosIncomplete = (props)=>{
    const { // postId,
    parentId , parentNodeId , todos , disabled , parentType , prepend , todoSupportedActions , todoSingularAction ,  } = props;
    // const { actions, performSingularAction } =
    //   usePostPageTodoListTodosSingularAction({ disabled, postId });
    const { Provider , navProps  } = useNavigationList(`PostPageTodoListTodosIncomplete|${parentId}`, useMemo(()=>({
            actions: todoSupportedActions,
            performSingularAction: todoSingularAction
        }), [
        todoSingularAction,
        todoSupportedActions
    ]));
    return /*#__PURE__*/ _jsxs(Provider, {
        children: [
            prepend,
            /*#__PURE__*/ _jsx(Droppable, {
                droppableId: JSON.stringify({
                    id: parentId,
                    nodeId: parentNodeId,
                    type: parentType
                }),
                type: ItemType.ChecklistItem,
                children: (dropProvided)=>/*#__PURE__*/ _jsxs(CardsWrapper, {
                        minHeight: 1,
                        ref: (element)=>{
                            dropProvided.innerRef(element);
                            navProps.ref.current = element;
                        },
                        children: [
                            /*#__PURE__*/ _jsx(PostPageTodoListTodosIncompleteMemo, {
                                todos: todos,
                                disabled: disabled,
                                parentId: parentId,
                                parentNodeId: parentNodeId,
                                parentType: parentType
                            }),
                            dropProvided.placeholder
                        ]
                    })
            })
        ]
    });
};
export default PostPageTodoListTodosIncomplete;
